/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Settings shell (redesign artboards 12, 28–31): page header + left sub-nav
// that stacks above the content on narrow screens.

import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Page, PageHeader } from '../console/ui';

interface SettingsNavItem {
  name: string;
  href: string;
  description: string;
}

const settingsNav: SettingsNavItem[] = [
  { name: 'Profile', href: '/settings/profile', description: 'Name, timezone, currency' },
  { name: 'Security', href: '/settings/security', description: 'Sign-in and sessions' },
  { name: 'Access keys', href: '/settings/access-keys', description: 'SSH keys, API keys' },
  { name: 'Launch templates', href: '/pods/templates', description: 'Also under GPU Pods' },
  { name: 'Notifications', href: '/settings/notifications', description: 'Email and alerts' },
  { name: 'Appearance', href: '/settings/appearance', description: 'Theme' },
];

const SettingsLayout: React.FC = () => (
  <Page>
    <PageHeader
      title="Settings"
      subtitle="Your profile and every credential - SSH keys and API keys for all three products - in one place."
    />
    <div className="flex flex-wrap gap-6 items-start">
      <nav className="ps-card flex-[1_1_220px] p-2 flex flex-col gap-0.5 min-w-0" aria-label="Settings sections">
        {settingsNav.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            className={({ isActive }) =>
              `flex flex-col gap-0.5 px-3 py-2.5 min-h-[44px] rounded-md text-sm transition-colors ${
                isActive ? 'bg-[#22120A] text-ps-text' : 'text-ps-text hover:bg-ps-hover'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className={isActive ? 'text-ps-accent font-medium' : 'font-medium'}>{item.name}</span>
                <small className="text-ps-subtle text-xs">{item.description}</small>
              </>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="flex-[4_1_560px] min-w-0 flex flex-col gap-5">
        <Outlet />
      </div>
    </div>
  </Page>
);

export default SettingsLayout;
